module.exports = __webpack_public_path__ + "static/media/ex-product.59760782.jpg";